import { createAsyncAction, createAction } from "typesafe-actions";
import definitionConstants from "store/features/templates/definition/definition.constants";
import { TemplateDefinition, TemplateMaterialSpecModel, TemplateViewModel } from "api";

const {
    FETCH_TEMPLATE_DETAILS_REQUEST,
    FETCH_TEMPLATE_DETAILS_SUCCESS,
    FETCH_TEMPLATE_DETAILS_FAILED,
    UPDATE_TEMPLATE_REQUEST,
    UPDATE_TEMPLATE_SUCCESS,
    UPDATE_TEMPLATE_FAILED,
    CREATE_TEMPLATE_REQUEST,
    CREATE_TEMPLATE_SUCCESS,
    CREATE_TEMPLATE_FAILED,
    VALIDATE_TEMPLATE_REQUEST,
    VALIDATE_TEMPLATE_SUCCESS,
    VALIDATE_TEMPLATE_FAILED,
    CLAEAR_TEMPLATE_DEFINITION,
} = definitionConstants;

export const fetchTemplateDetails = createAsyncAction(
    FETCH_TEMPLATE_DETAILS_REQUEST,
    FETCH_TEMPLATE_DETAILS_SUCCESS,
    FETCH_TEMPLATE_DETAILS_FAILED
)<{ templateName: string }, TemplateDefinition & { parsedXml: string }, ErrorHandler>();

export const createTemplate = createAsyncAction(
    CREATE_TEMPLATE_REQUEST,
    CREATE_TEMPLATE_SUCCESS,
    CREATE_TEMPLATE_FAILED
)<TemplateViewModel, void, ErrorHandler>();

export const updateTemplate = createAsyncAction(
    UPDATE_TEMPLATE_REQUEST,
    UPDATE_TEMPLATE_SUCCESS,
    UPDATE_TEMPLATE_FAILED
)<TemplateViewModel, void, ErrorHandler>();

export const validateTemplate = createAsyncAction(
    VALIDATE_TEMPLATE_REQUEST,
    VALIDATE_TEMPLATE_SUCCESS,
    VALIDATE_TEMPLATE_FAILED
)<TemplateMaterialSpecModel, { preview: string }, ErrorHandler>();

export const clearTemplateDefinition = createAction(CLAEAR_TEMPLATE_DEFINITION)();
